module.exports = __webpack_public_path__ + "img/Im3.1b91795f.png";